import { action, computed, observable } from 'mobx'
import { JtechAxios } from 'src/plugins/axios'
import { JtechStore } from 'src/plugins/mobx'

export default class VersionDisplayModel {
    @observable displayVersion = '';
    @observable backendVersion = '';
    @observable frontendVersion = '';

    static getInstance () {
      return JtechStore.getSingleton('versionDisplayModel', new VersionDisplayModel())
    }

    @action.bound
    setDisplayVersion (version) {
      this.displayVersion = version
    }

    @action.bound
    setBackendVersion (version) {
      this.backendVersion = version
    }

    @action.bound
    setFrontendVersion (version) {
      this.frontendVersion = version
    }

    async fetchBackendVersion () {
      try {
        const dataResponse = await JtechAxios.request().get('/version')
        return dataResponse.data
      } catch (ex) { }
    }

    compareVersions (v1, v2) {
      const v1Parts = this.convertVersionToInteger(v1)
      const v2Parts = this.convertVersionToInteger(v2)
      if (v1Parts > v2Parts) return v1
      return v2
    }

    convertVersionToInteger (version) {
      const numericOnly = version.replace(/[^0-9]/g, '')
      return parseInt(numericOnly, 10)
    }
}
